import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface JobTitleFieldProps {
  control: Control<FormProps>;
}

export function JobTitleField({ control }: Readonly<JobTitleFieldProps>) {
  return (
    <Controller
      name="jobTitle"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label="Job Title"
          fullWidth
          autoComplete="organization-title"
        />
      )}
    />
  );
}
